import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService } from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;
@Component({
  selector: 'app-qc-customer-list',
  templateUrl: './qc-customer-list.component.html',
  styleUrls: ['./qc-customer-list.component.scss']
})
export class QcCustomerListComponent extends GridBaseCase{
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = new Array<any>();
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:string = null;
  searchValue:any = null;//查询内容
  searchPlaceholder:string = null;//搜索框占位符
  isShowSearchInput:boolean = false;//是否显示搜索框
  vipTypeArr=[];//会员类型数组
  vipTypeId:string="";//会员类型id
  selectVal = null;//搜索月份 注册时间
  selectValtext:string ="请选择"; //  默认空的显示
  selectValsell= null; // 搜索 销售时间
  selectValsellText:string="请选择";
  menberInfoList:Array<any> = [];//会员足迹
  selectrue:boolean=true; // 按钮点击
  selectChecked:boolean=true;//注册日期
  giftvipTypeId:string=""; // 活动类型
  giftTypeArr=[];//活动类型数组
  articeType: any = "";
  articeTypeList: any = [
    { id: "1", name: "全部" },
    { id: "2", name: "买三赠一" },
  ];//筛选类型数据源
  articeSelectText: any = "全部";
  campaignValue:any = null;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    public native: NativeService
  ) { super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.selectVal = _date.getFullYear() + "/" + (_month < 10 ? ("0" + _month) : _month);
    this.selectValsell = _date.getFullYear() + "/" + (_month < 10 ? ("0" + _month) : _month);
  }

  ngAfterViewInit(){
    let that = this;
    that.searchPlaceholder = "姓名或手机号";
    let selectItem = that.element.selectItemList.selectItem;
    if(selectItem.length > 0){
      selectItem.forEach(item=>{
        if(item.elementType && item.elementType=="Search") {
          that.searchPlaceholder = "姓名或手机号";
          // that.searchPlaceholder = item.text;
          that.isShowSearchInput = true;
        }
      })
    }
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
          that.campaignValue = item.campaigInput;
        }
      })
    }

      that.loading = false;
      that.apiObj['status'] =true;
    //   let vipArr=that.com.GetStorageKey("vipType") || [];
    that.vipTypeArr.push(
      {
        a_Name:"全部"
      },{
      a_Name:"幼儿新客"
    },{
      a_Name:"妈妈奶粉新客"
    },{
      a_Name:"忠实会员"
    },
    {
      a_Name:"守护计划"
    },
    {
      a_Name:"四段会员"
    },
    {
      a_Name:"四段会员-瑞铂"
    },
    {
      a_Name:"四段会员-超启"
    }
    );
    // if(vipArr.length>0){
    //   that.vipTypeArr=vipArr;
    // }else{
    //   that.LoadVipType();
    // }
    that.vipTypeId="";
  }
  // 选择按钮弹窗
  EventReturnsaluse(){
    console.log("选择按钮的弹窗");
  }
  EventDateTimeClick(){
    let that = this;
    console.log(that.selectVal);
    //debugger;
    let _obj = {
      value: that.selectVal,
      format: "yyyymm"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.selectVal = that.formatDate(data.value);
      that.selectChecked=true;
      that.LoadData(1);
    }).catch(eror => {
      console.log(eror);
      // that.selectVal = "";
      // console.log(that.selectVal,"取消的月份");
    });
  }
  EventDateTimeClicksell(){
    let that = this;
    console.log(that.selectValsell ,"llllllll")
    // if(that.selectValsell = ""){
    //   that.selectrue = true;
    // }
      console.log(that.selectValsell);
      let _obj = {
        value: that.selectValsell,
        format: "yyyymm"
      };
      that.native.IosselectDateTime(_obj).then(data => {
        that.selectValsell = that.formatDate(data.value);
        console.log( that.selectValsell,"选择的月份")
        that.selectrue = true;
        that.LoadData(1);
      }).catch(eror => {
        console.log(eror);
        // that.selectValsell = "";
        // console.log(that.selectValsell,"取消的月份");
      });  
  }
  close(){
    const that =this;
    that.selectrue = false;
    that.selectValsell = "";
    that.LoadData(1);
  }
  close2(){
    const that =this;
    that.selectChecked = false;
    that.selectVal = "";
    that.LoadData(1);
  }
  formatDate(date) {
    if (date) {
      let _y = date.split("-")[0];
      let _m = date.split("-")[1];
      // let _d = _date.getDate();
      // return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
      return _y + "/" + (_m < 10 ? "0" + _m : _m);
    } else {
      return date;
    }
  }
  //会员类型改变
  changeTypeSelect(e)
  {
    const that=this;
    that.vipTypeId=e.target.value;
    if(that.vipTypeId=="全部"){
      that.vipTypeId="";
    }
    
    that.LoadData(1);
  }
  
  //会员类型数据
  LoadVipType()
  {
    let that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName="TBNewMemberTypeXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    // body.RowsPerPage = 2;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.SpecialParameter="viptype";
    that.http.post(app.DEFAULTURL, body).then(data => {
     if(data.ResponseMessage.Success)
     {
      that.vipTypeArr.push({a_ID:"-1",a_Name:"全部",a_Code:"-1"});
      data.Status.Datas.forEach(function (item) {
        let pushObj={};
            pushObj["a_ID"]=item.a_ID;
            pushObj["a_Name"]=item.a_Name;
            pushObj["a_Code"]=item.a_Code;
       that.vipTypeArr.push(pushObj);
      })
      localStorage.setItem("vipType",JSON.stringify(this.vipTypeArr));
    }
    });
  }
  EventLink(event,item){
    const that=this;
    console.log(item,"itemieememmemmemm")
    console.log(that.menberInfoList,"jjjjjjjjjjjjjjjjj")
    // debugger;
    // console.log(item);
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName="UpdateMemberInfo";
      body.OpType = "edite";
      body.ConfigType = "form";
      body.RowsPerPage = app.RowsPerPage;
      // body.RowsPerPage = 2;
      body.PageNumber = 1;
      body.Client.PageName = "TBNewMemberTypeXML";
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      let el=that.menberInfoList.find(ut=>ut.Mobile==item.phones.value.toString());
      console.log(el,"zmmzmmzmmzmzmzmzmmzzm&&&&&&&&&&&")
      body.RequestBody=JSON.stringify(el);
         that.msg.Loading("加载中，请稍后...").then(load=>{
          that.http.post(app.DEFAULTURL, body).then(data => {
            // debugger;
            load.dismiss();
            if(data.ResponseMessage.Success)
            {
             item.id.value=data.Status.Datas[0].id;
             item.wechat_id.value=data.Status.Datas[0].Openid;
             localStorage.setItem("customerTag",JSON.stringify(item));
             localStorage.setItem("information",JSON.stringify(item));
             that.com.setHistoryUrl(false);
             that.com.Go(event.url+item.id.value + "&" + that.com.getNowDatetime);
            }else{
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
           }).catch(err=>{
            load.dismiss();
             that.msg.Alert("请求失败,请联系管理员");
           });
           load.present();
         });
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  }
     /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    const that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    if(e.keyCode == 13 || type=='search'){
      const _searchObj = {
        pageName:PageName,
        searchInput:that.searchValue,
        campaigInput:that.campaignValue
      };
      that.com.SaveSearchInfo(_searchObj);
      this.LoadData(1);
    }
  }
  /**
   * 返回这个月有多少天
   * @param data 当前日期
   */
  getCountDays(data){
    let curDate:any = new Date(data.replace("-","/"));
    /* 获取当前月份 */
        var curMonth = curDate.getMonth();
        curDate.setMonth(curMonth + 1);
        curDate.setDate(0);
        return curDate.getDate();
  }
  LoadData(PageNumber){
    let that = this;
    console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      if(!that.searchValue){
        let searchArr = that.com.GetStorageKey("searchArray") || [];
        if(searchArr.length > 0){
          searchArr.forEach(item=>{
            if(item.pageName == that.pageName){
              that.searchValue = item.searchInput;
              that.campaignValue = item.campaigInput;
              
            }
          })
        }
      }
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '加载中请稍后';
      that.menberInfoList=[];
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    body.ConfigName="MemberListInfo";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    // body.RowsPerPage = 2;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody={};
    body.RequestBody["mobile"]="";
    body.RequestBody["startTime"]="";
    body.RequestBody["joindateStart"]="";
    body.RequestBody["joindateEnd"]="";
    body.RequestBody["endTime"]="";
    body.RequestBody["newCustomerType"]="";
    if(that.searchValue){
      body.RequestBody["mobile"] = that.searchValue.trim();
    }
    if(that.campaignValue){
      body.RequestBody["campaign"] = that.campaignValue.trim();
    }
    
    if(that.selectVal){
      body.RequestBody["startTime"]=that.selectVal.replace("/","-")+"-01 00:00:00";
      body.RequestBody["endTime"]=that.selectVal.replace("/","-")+"-"+that.getCountDays(that.selectVal+"-01")+" 23:59:59";
    }
    if(that.selectValsell){
      body.RequestBody["joindateStart"]=that.selectValsell.replace("/","-")+"-01 00:00:00";
      body.RequestBody["joindateEnd"]=that.selectValsell.replace("/","-")+"-"+that.getCountDays(that.selectValsell+"-01")+" 23:59:59";
    }
    // if(that.selectValsell){
    //   body.RequestBody["startTime"]=that.selectValsell.replace("/","-")+"-01 00:00:00";
    //   body.RequestBody["endTime"]=that.selectValsell.replace("/","-")+"-"+that.getCountDays(that.selectValsell+"-01")+" 23:59:59";
    // }
   
    body.RequestBody["Code"]=that.com.GetAccount.CustomerID;
   
    if(that.vipTypeId)
     {
      body.RequestBody["newCustomerType"]=that.vipTypeId;
     }

    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
      campaigInput:that.campaignValue

    };
    that.com.SaveSearchInfo(_searchObj);
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.menberInfoList = [];
        that.dataArrayList=[];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
       
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      that.loading = true;
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        let arrayListMemberInfo:Array<any> = new Array<any>();
        if(data.Status.Datas.length>0){
          data.Status.Datas.forEach(function (item) {
            that.menberInfoList.push(item);
            let objfield = {};
            let arrType=[];
            that.element.selectItemList.selectItem.forEach((element, index) => {
              // console.log(element,"&&&&&&&&&&&&&&&&&&&&&&&&");
              if (element.bindingField) {
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
              if((element.bindingField == 'birthday' || element.bindingField == 'pre_Date') && objfield[element.bindingField].value){
                objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
              }
              // if(element.formatter && element.formatter == "type"){
              //   if(objfield[element.bindingField].value&&objfield[element.bindingField].value){
              //     if(objfield[element.bindingField]=="typeall")
              //     {
              //       delete objfield[element.bindingField];
              //     }
              //   arrType.push(element.text);
              //   }
                  // objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              // }
              if(that.pageName!="MemberListInfo"){
                that.com.CustomerTag(element,objfield,arrType);//获取所有标签
              }
            });
            console.log(objfield,"zmmzmmzmmzmzm");
            console.log(objfield["isAuth"]);
           
            if(objfield["name"] && objfield["name"].value){
             
              console.log(objfield["isAuth"].value,"数值数值");
              objfield["name"].value=that.com.FormatName(objfield["name"].value , !objfield["isAuth"].value);
            }
            if(objfield["phone"]){
              if(objfield["phone"].value){
                let phone:string=objfield["phone"].value;
                objfield["phone"].value=that.com.PhoneNum(phone.toString(),!objfield["isAuth"].value);
              }
            }
            if(objfield["birthday"]){
              if(objfield["birthday"].value){
                if(objfield["birthday"].value.split(" ")[0]){
                  objfield["birthday"].value=objfield["birthday"].value.split(" ")[0];
                }
              }
            }
            if(body.ConfigName=="MemberListInfo"){//会员足迹
              arrayListMemberInfo.push(objfield);
            }else{
              that.dataArrayList.push(objfield);
            }
          });
        }
        if(body.ConfigName=="MemberListInfo"){
          arrayListMemberInfo.forEach(item=>{
            console.log(item,"数据******")
            let msg:Array<string>=[];
            let value="";
            if(item.info1 && item.info1.value ){
              value=item.info1.value.trim();
            }
            let inf2="";
            if(item.inf2 && item.inf2.value){
              inf2=item.inf2.value.trim();
            }
            if(item.memberstype && item.memberstype.value){
              item.memberstype.value=item.memberstype.value.trim().replace("||","");
              
              // item.memberstype.value.split("|");
              
              
            }
            let inf4="";
            if(item.inf4 && item.inf4.value){
              inf4=item.inf4.value.trim();
            }
            let inf5="";
            if(item.inf5 && item.inf5.value){
              inf5=item.inf5.value.trim();
            }
            let inf6="";
            if(item.inf6 && item.inf6.value){
              inf6=item.inf6.value.trim();
            }
            let inf7="";
            if(item.inf7 && item.inf7.value){
              inf6=item.inf7.value.trim();
            }
            let inf8="";
            if(item.inf8 && item.inf8.value){
              inf6=item.inf8.value.trim();
            }
            item.info1.value="";
            if(value){
              msg.push(value);
            }
            if(inf2){
              msg.push(inf2);
            }
            if(inf4){
              msg.push(inf4);
            }
            if(inf5){
              msg.push(inf5);
            }
            if(inf6){
              msg.push(inf6);
            }
            if(inf7){
              msg.push(inf7);
            }
            if(inf8){
              msg.push(inf8);
            }
            item.info1.value=msg.toString();
            console.log(item.info1.value,"标签数组")
            // console.log(item.item.memberstype.value.split("|"),"&&&&&&&&&&&&标签")
            item.memberstype.value = item.memberstype.value.split("|");
            console.log(item.memberstype.value,"&&&&&&&&&&&&标签")
            that.dataArrayList.push(item);
            console.log( that.dataArrayList,"数据结果&&&&&")
          });
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
/**
 * 
 * @param e 活动类型改变
 */
 articeChangeSelect(e) {
  let that = this;
  that.articeType = e.target.value;
  that.articeTypeList.forEach((item) => {
    if (item["id"] == that.articeType) {
      that.articeSelectText = item["name"];
    }
  })
  that.LoadData(1);


  // that.LoadDataList();
}
}
